<template>
  <div class="children-table__row">
    <div class="children-table__row-col col-month">{{ month }}月</div>
    <div class="children-table__row-col col-height">
      <v-text-field
        v-model.number="localHeight"
        @update:modelValue="emitHeight"
        density="compact"
        hide-details
        variant="outlined"
        type="number"
        suffix="cm"
      />
    </div>
    <div class="children-table__row-col col-weight">
      <v-text-field
        v-model.number="localWeight"
        @update:modelValue="emitWeight"
        density="compact"
        hide-details
        variant="outlined"
        type="number"
        suffix="kg"
      />
    </div>
    <div class="children-table__row-col col-other">
      <v-text-field
        v-model="localRemarks"
        @update:modelValue="emitRemarks"
        density="compact"
        hide-details
        variant="outlined"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { NurseryGrowthResponse } from 'chaild-api/lib';

export default defineComponent({
  props: {
    record: {
      type: Object as PropType<NurseryGrowthResponse | null>,
      default: null,
    },
    month: {
      type: Number,
      required: true,
    }
  },

  // ⭕️ 修正4: 入力途中の文字が消えないよう、自分の手元にデータをコピーして持つ
  data() {
    return {
      localHeight: null as number | null,
      localWeight: null as number | null,
      localRemarks: null as string | null,
    };
  },

  // ⭕️ 修正5: 親からデータが降ってきたら手元のデータを更新する
  watch: {
    record: {
      immediate: true,
      handler(newVal: NurseryGrowthResponse | null) {
        this.localHeight = newVal ? newVal.height : null;
        this.localWeight = newVal ? newVal.weight : null;
        this.localRemarks = newVal ? newVal.remarks : null;
      }
    }
  },

  methods: {
    // ⭕️ 修正6: 入力があるたびに手元のデータを親に送信 ($emit)
    emitHeight() {
      this.$emit('inputHeight', this.localHeight);
    },
    emitWeight() {
      this.$emit('inputWeight', this.localWeight);
    },
    emitRemarks() {
      this.$emit('inputRemarks', this.localRemarks);
    },
  },
});
</script>

<style lang="scss" scoped>
/* スタイルは親コンポーネントで定義されているため空でOK */
</style>